<template>
    <div class="item-type-image">
        <VuePannellum
            v-if="item.has360"
            type="equirectangular"
            :src="imageUrl"
            :hfov="item.hasFOV ? item.metadata.fov : 120"
            :autoLoad="true"
            :showZoom="true"
            :showFullscreen="true"
        />
        <template v-else>
            <div class="gallery-image" :style="imageStyles"></div>
        </template>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

// Components
import VuePannellum from '@/components/pannellum'; // TODO: upgrade

export default {
    name: 'Photo',
    props: {
        item: {
            type: Object,
            required: true,
        }
    },
    components: {
        VuePannellum,
    },
    computed: {
        imageUrl() {
            return `${this.item.url}/${this.item.file_id}?t=${this.item.timestamp}`;
        },
        imageStyles() {
            return {
                backgroundImage: `url('${this.imageUrl}')`,
                //width: this.item.hasDimensions ? `${this.item.dimensions.width}px` : '',
                //height: this.item.hasDimensions ? `${this.item.dimensions.height}px` : '',
            }
        }
    },
}
</script>

<style lang="scss" scoped>

.item-type-image {
    position: relative;
    width: 100%;
    height: 100%;

    .review-image-wrapper {
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        height: 100%;
    }

    .gallery-image {
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
        height: 100%;
        max-height: 100vh;
    }
}
</style>
